import { getData } from 'country-list';
import React, { useState } from 'react';
import { Form, Button, Card, Spinner } from "react-bootstrap";
import "./Signup.css";
import Swal from 'sweetalert2';

const FreeTrialForm = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    whatsapp: '',
    country: '',
    course: '',
  });

  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const validate = (data) => {
    const newErrors = {};
    if (!data.firstName.trim()) newErrors.firstName = 'First name is required.';
    if (!data.lastName.trim()) newErrors.lastName = 'Last name is required.';
    if (!data.email.trim()) newErrors.email = 'Email is required.';
    else if (!/\S+@\S+\.\S+/.test(data.email)) newErrors.email = 'Enter a valid email address.';
    if (!data.whatsapp.trim()) newErrors.whatsapp = 'WhatsApp number is required.';
    else if (!/^\+?[0-9\s]{7,15}$/.test(data.whatsapp)) newErrors.whatsapp = 'Enter a valid phone number.';
    if (!data.country) newErrors.country = 'Please select a country.';
    if (!data.course) newErrors.course = 'Please select a course.';
    return newErrors;
  };

  const handleChange = (e) => {
    const updated = { ...formData, [e.target.id]: e.target.value };
    setFormData(updated);
    if (submitted) {
      setErrors(validate(updated));
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    setSubmitted(true);
    const validationErrors = validate(formData);

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: 'Please fill all required fields correctly.',
        confirmButtonColor: '#0042a6',
      });
      return;
    }

    setIsLoading(true);

    try {
       await fetch(
        "https://script.google.com/macros/s/AKfycbwsQnnzwVrKpMyrG1Ospr4QBilwMVROPdLLpC9wtzJqzi_QmcMRDzqzWi5uGUsdMcm7Jg/exec",
        {
          method: "POST",
          mode: "no-cors",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      // Success SweetAlert with thank you message
      Swal.fire({
        icon: 'success',
        title: 'Registration Successful! 🎉',
        html: `
          <div style="text-align: center;">
            <p style="font-size: 16px; margin-bottom: 10px;">
              Thank you <strong>${formData.firstName} ${formData.lastName}</strong>!
            </p>
            <p style="font-size: 14px; color: #666;">
              We have received your registration for <strong>${formData.course}</strong>.
            </p>
            <p style="font-size: 14px; color: #666; margin-top: 10px;">
              Our team will contact you shortly on WhatsApp.
            </p>
            <hr style="margin: 15px 0;">
            <p style="font-size: 13px; color: #999;">
              🌟 Welcome to the learning journey!
            </p>
          </div>
        `,
        confirmButtonText: 'Continue',
        confirmButtonColor: '#0042a6',
        backdrop: true,
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          // Reset form after success
          setFormData({
            firstName: "",
            lastName: "",
            email: "",
            whatsapp: "",
            country: "",
            course: "",
          });
          setSubmitted(false);
          setErrors({});
        }
      });

    } catch (err) {
      console.error("Error:", err);
      Swal.fire({
        icon: 'error',
        title: 'Submission Failed',
        text: 'Something went wrong. Please try again later.',
        confirmButtonColor: '#0042a6',
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Card className='card'>
      <h3 className="text-center mb-4" style={{ color: '#e0ecff', fontWeight: 700 }}>
        Free Trial Class
      </h3>
      <Form onSubmit={handleSubmit} noValidate>

        <Form.Group className="mb-2" controlId="firstName">
          <Form.Control
            type="text"
            placeholder="First Name"
            value={formData.firstName}
            onChange={handleChange}
            className={`input${errors.firstName ? ' input-error' : ''}`}
          />
          {errors.firstName && <div className="error-text">{errors.firstName}</div>}
        </Form.Group>

        <Form.Group className="mb-2" controlId="lastName">
          <Form.Control
            type="text"
            placeholder="Last Name"
            value={formData.lastName}
            onChange={handleChange}
            className={`input${errors.lastName ? ' input-error' : ''}`}
          />
          {errors.lastName && <div className="error-text">{errors.lastName}</div>}
        </Form.Group>

        <Form.Group className="mb-2" controlId="email">
          <Form.Control
            type="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            className={`input${errors.email ? ' input-error' : ''}`}
          />
          {errors.email && <div className="error-text">{errors.email}</div>}
        </Form.Group>

        <Form.Group className="mb-2" controlId="whatsapp">
          <Form.Control
            type="tel"
            placeholder="Whatsapp Number"
            value={formData.whatsapp}
            onChange={handleChange}
            className={`input${errors.whatsapp ? ' input-error' : ''}`}
          />
          {errors.whatsapp && <div className="error-text">{errors.whatsapp}</div>}
        </Form.Group>

        <Form.Group className="mb-2" controlId="country">
          <Form.Select
            value={formData.country}
            onChange={handleChange}
            className={`input${errors.country ? ' input-error' : ''}`}
          >
            <option value="" disabled>Country</option>
            {getData().map((c) => (
              <option key={c.code} value={c.code}>
                {c.name}
              </option>
            ))}
          </Form.Select>
          {errors.country && <div className="error-text">{errors.country}</div>}
        </Form.Group>

        <Form.Group className="mb-2" controlId="course">
          <Form.Select
            value={formData.course}
            onChange={handleChange}
            className={`input${errors.course ? ' input-error' : ''}`}
          >
            <option value="" disabled>Select Course</option>
            <option>Noorani Qaida</option>
            <option>Basic Quran Reading</option>
            <option>Quran Memorization</option>
            <option>Salah / Kalmas / Duas</option>
          </Form.Select>
          {errors.course && <div className="error-text">{errors.course}</div>}
        </Form.Group>

        <div className="d-grid mt-3">
          <Button
            type="submit"
            disabled={isLoading}
            className="reg-btn d-flex align-items-center justify-content-center gap-2"
          >
            {isLoading ? (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                style={{ color: 'white' }}
              />
            ) : (
              'REGISTER'
            )}
            {isLoading && <span className="ms-2">Processing...</span>}
          </Button>
        </div>

      </Form>
    </Card>
  );
};

export default FreeTrialForm;